var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertCircleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_476_178)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.50008 5.66675V8.50008M8.50008 11.3334H8.50716M15.5834 8.50008C15.5834 12.4121 12.4121 15.5834 8.50008 15.5834C4.58806 15.5834 1.41675 12.4121 1.41675 8.50008C1.41675 4.58806 4.58806 1.41675 8.50008 1.41675C12.4121 1.41675 15.5834 4.58806 15.5834 8.50008Z",
    stroke: "#7E7D7D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_476_178"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertCircleIcon);
export default __webpack_public_path__ + "static/media/alert-circle-icon.1c6aec4a0826e9d1db56a379fcf8952e.svg";
export { ForwardRef as ReactComponent };